import React from 'react';
// import { payRateHistCols } from '../constants/EmployeeCols';
import ReactTable from '../components/ReactTable';
import { usePayRateHistCols } from '../hooks/EmployeeCols';
import { AntTabs, AntTab } from '../components/common/Tabs'
import EmployeeAltRates from '../components/EmployeeAltRates'
export default function PayRateHistory(props) {
  const payRateHistCols = usePayRateHistCols();
  const [value, setValue] = React.useState(0)


  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const tabs = [
    {
      display: 'History',
      value: 0
    },
    {
      display: 'Alt Rates',
      value: 1
    }
  ]


  return (
    <>
      <AntTabs
        color={props.fetchInitialData.credentials.primaryAppColor}
        value={value}
        onChange={handleChange}
        aria-label='ant example'
      >
        {tabs.map((cur, index) => {
          return (
            <AntTab
              key={index}
              label={cur.display}
              value={cur.value}
              color={props.fetchInitialData.credentials.primaryAppColor}
            />
          )
        })}
      </AntTabs>
      {value === 0 && (
        <div style={{ marginTop: '1rem' }}>
          <ReactTable cols={payRateHistCols} data={props.data} />
        </div>
      )}
      {value === 1 && (
        <div style={{ marginTop: '1rem' }}>
          <EmployeeAltRates {...props} />
        </div>
      )}
    </>
  )
}
